import React, { useMemo } from 'react';
import {
  getValueFromFormState,
  useFieldController,
  useFormMethods,
} from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import Field from '../../shared/ui/Field';
import MemoizedCheckbox from './CheckboxFactory';
import { weekDays } from '../../shared/configs/selectionData/days';
import { useEvent } from '../../../../hooks/useEvent';

const {
  desk: {
    workingDays: createDaysName,
    isCommonSchedules: createIsCommonSchedulesName,
    scheduleSettings: createSchedulesName,
  },
} = fieldPathBuilders;
const days = [...weekDays.entries()];

const defaultIsDisabled = () => false;

const SelectDeskWorkingDays = ({
  deskIndex,
  isDisabled = defaultIsDisabled,
}) => {
  const {
    field: { value, onChange },
    fieldState,
  } = useFieldController({
    name: createDaysName(deskIndex),
    rules: { required: 'Укажите рабочие дни' },
    defaultValue: [],
  });

  const { getValues, unregister } = useFormMethods();

  const names = useMemo(() => createFieldNames(deskIndex), [deskIndex]);

  const handleChange = useEvent((values) => {
    onChange(sortValues(values));

    const { isCommonSchedulesName, schedulesName } = names;

    if (
      !values?.length &&
      getValueFromFormState(getValues(), isCommonSchedulesName)
    ) {
      unregister(schedulesName);
    }
  });

  return (
    <Field.Memoized
      type={Field.types.checkboxGroup}
      formItemLabel="Рабочие дни"
      required
      errorMessage={fieldState.error?.message}
      value={value}
      onChange={handleChange}
    >
      {days.map(([id, label]) => {
        const checked = value?.includes(id);

        return (
          <MemoizedCheckbox
            key={id}
            deskIndex={deskIndex}
            checked={checked}
            value={id}
            label={label}
            disabled={isDisabled(id)}
          />
        );
      })}
    </Field.Memoized>
  );
};

export default SelectDeskWorkingDays;

function sortValues(values) {
  return days.reduce((acc, [id]) => {
    if (values?.includes(id)) acc.push(id);
    return acc;
  }, []);
}

function createFieldNames(deskIndex) {
  return {
    isCommonSchedulesName: createIsCommonSchedulesName(deskIndex),
    schedulesName: createSchedulesName(deskIndex),
  };
}
